
import React from 'react'
import async from 'async'
import request from 'superagent';

class Loader extends React.Component {
    render() {
        return (
            <div className={`loader-overlay modal${this.props.active ? ' is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-content" style={{width:'1em', margin:'0 auto'}}>
                    <div className="loader"/>
                </div>
            </div>
        )
    }
}

class FileUploader extends React.Component
{
    constructor() {
        super(...arguments);
        this.state = {
            input_key: `input-key-${Date.now()}`,
            limit: this.props.limit || -1,
            uploaded: []
        };
        this.support_formats = ['jpeg', 'jpg', 'png', 'gif', 'zip', 'rar', 'pdf'];
    }

    handleUpload(e) {
        if (this.is_uploading) {
            return;
        }

        const file_list = e.target.files;
        const files = [];
        for (let i = 0; i < file_list.length; i++) {
            files.push(file_list[i]);
        }
        const uploaded = [].concat(this.state.uploaded || []);
        const from_index = uploaded.length;
        let index = from_index;
        async.series(files.map((file, i) => done => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const f = {
                    src: reader.result,
                    name: file.name,
                    file: file,
                    id: 'pending-' + (++index),
                    type: file.type,
                    size: file.size,
                    is_valid: true
                };
                if (f.size > 20 * 1024 * 1024) {
                    f.is_valid = false;
                    f.error = app.trans('uploader.size') + ' > 20MB'
                } else if (this.support_formats.indexOf(f.type.split('/').pop()) < 0) {
                    f.is_valid = false;
                    f.error = app.trans('uploader.invalid_format', {format: this.support_formats.join(', ')});
                }
                uploaded[from_index + i] = f;
                this.setState({ uploaded: uploaded });
                done(null, f);
            };
            reader.onerror = () => {
                done();
            };
            reader.readAsDataURL(file);
        }), (err, files) => {
            this.uploadFiles(files.filter(v => v), from_index);
        });
    }

    getUploadParams() {
        if (typeof this.props.params === 'object') {
            return Object.assign({}, this.props.params);
        }
        return JSON.parse(this.props.params || '{}');
    }

    uploadFiles(files, from_index = 0) {
        const params = this.getUploadParams() || {};
        if (this.is_uploading) {
            return;
        }
        this.is_uploading = true;
        this.setState({ is_uploading: true });
        async.series(files.map((item, i) => done => {
            if (!item.is_valid) {
                this.state.uploaded[from_index + i].uploaded = item.name;
                return done(null, item.name);
            }
            request
                .post('/upload/file')
                .field('form_id', this.props.formId)
                .field($('meta[name=csrf_name]').attr('content'), $('meta[name=csrf]').attr('content'))
                .attach('file', item.file)
                .then((res) => {
                    this.state.uploaded[from_index + i].uploaded = res.body.name;
                    this.state.uploaded[from_index + i].value = res.body.path;
                    return done(null, res.body.name);
                })
                .catch((err) => {
                    this.state.uploaded[from_index + i].uploaded = item.name;
                    this.state.uploaded[from_index + i].is_valid = false;
                    this.state.uploaded[from_index + i].error = app.trans('uploader.invalid_format');
                    return done();
                });
        }), (err, res) => {
            if (err) {
                return console.error(err);
            }

            this.callback();

            this.setState({ loaded: this.state.loaded, input_key: `input-key-${Date.now()}`, is_uploading: false });
            this.is_uploading = false;
        });

        // app.api().upload('/upload/upload', files.map(f => (
        //     {field:'files[]', file:f.file}
        // )), Object.assign({}, params), (res) => {
        //     const images = this.state.images || [];
        //     console.log(images);
        //     res.assets.forEach((m, i) => {
        //         console.log(from_index + i, m.thumb, images[from_index + i]);
        //         images[from_index + i].uploaded = m.thumb;
        //         images[from_index + i].data = m;
        //         images[from_index + i].id = m.id;
        //     });
        //     this.setState({ images: images, input_key: `input-key-${Date.now()}`, is_uploading: false });
        //     this.is_uploading = false;
        // });
    }

    callback(uploaded) {
        if (typeof(this.props.callback) === 'function') {
            this.props.callback((uploaded || this.state.uploaded).filter(v => v.is_valid));
        }
    }

    handleRemove(i) {
        let uploaded = this.state.uploaded;
        uploaded[uploaded.length - i - 1] = null;
        uploaded = uploaded.filter(img => img);
        this.callback(uploaded);
        this.setState({ uploaded: uploaded });
    }

    canUploadMore() {
        return this.state.limit < 0 || !this.state.uploaded || this.state.limit > this.state.uploaded.length;
    }

    render() {
        const uploaded = this.state.uploaded;
        const limit = this.props.limit;
        const is_uploading = this.state.is_uploading;
        return (
            <div className={`in2-image-uploader-container`}>
                <div className="form-file">
                    {this.canUploadMore() ? (
                        <div className="file-item">
                            <label className="file-add" htmlFor={this.props.id}>
                                <input type="file" name={this.props.fieldName} key={this.state.input_key} accept={this.support_formats.map(v => `.${v}`).join(', ')} id={this.props.id} onChange={is_uploading ? null : this.handleUpload.bind(this)} multiple={true}/>
                                <div className="icon-cloud_upload upload-icon"/>
                                <div className="upload-text">
                                    <span className="icon is-large">
                                        {is_uploading ? (
                                            <span className="loader"></span>
                                        ) : (
                                            <i className="fas fa-paperclip fa-2x"></i>
                                        )}
                                    </span>
                                    <p>{is_uploading ? app.trans('uploader.uploading') : app.trans('uploader.attach_file')}</p>
                                    <p>{limit > 0 ? (( limit - uploaded.length > 0 ? (`${uploaded.length}/${limit}`) : null )) : null}</p>
                                </div>
                            </label>
                        </div>
                    ) : null}
                    {uploaded ? ([].concat(uploaded).reverse().slice(0, this.props.limit).map((file, i) => {
                        return (
                            <div className={`file-item${file.is_valid === false ? ' is-invalid' : ''}`}
                                 key={`uploaded-file-${file.id}`}>
                                <Loader active={!file.uploaded || file.is_valid === undefined} text={`Uploading`}/>
                                {file.type && file.type.startsWith('image') && file.is_valid ? (
                                    <div className="type-image"
                                         style={{ backgroundImage: `url(${file.src})`}}/>
                                ) : (
                                    <div className={`type-file`}>
                                        <span className={`icon is-large`}>
                                            <i className="fas fa-file"></i>
                                        </span>
                                        <div className={`name is-size-7`}>{file.name}</div>
                                        {file.error ? (<div className={`is-size-7 has-text-weight-bold`}>{file.error}</div>) : null}
                                    </div>
                                )}
                                <span className="icon close-btn tool-btn"
                                      onClick={this.handleRemove.bind(this, i)}>
                                    <i className="fas fa-times-circle"></i>
                                </span>
                                {file.is_valid === false ? null : (<input type="hidden" name={`${this.props.fieldName}[]`} defaultValue={file.value}/>)}
                            </div>
                        )
                    })) : null}
                </div>
                <p className={`help`}>{app.trans('uploader.help', {format: this.support_formats.join(', ')})}</p>
            </div>
        )
    }
}

export default FileUploader;
